module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh1",
    attrs: {
      "id": "Contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Table of Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Preface")]), _c('br'), _vm._v("by Stephen Davis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Foreword")]), _c('br'), _vm._v("by Thomas J. Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 1")]), _c('br'), _vm._v("John Bell Hood: The Son and the Soldier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 2")]), _c('br'), _vm._v("Robert E. Lee’s Opinion of John Bell Hood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 3")]), _c('br'), _vm._v("Jeff Davis, Joe Johnston, and John Bell Hood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 4")]), _c('br'), _vm._v("The Cassville Controversy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 5")]), _c('br'), _vm._v("The Battles for Atlanta: Hood Fights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 6")]), _c('br'), _vm._v("Desperate Times, Desperate Measures: The Tennessee Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 7")]), _c('br'), _vm._v("John Bell Hood: Feeding and Supplying His Army")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 8")]), _c('br'), _vm._v("Frank Cheatham and the Spring Hill Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 9")]), _c('br'), _vm._v("John Bell Hood and the Battle of Franklin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 10")]), _c('br'), _vm._v("The Death of Cleburne: Resentment or Remorse?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 11")]), _c('br'), _vm._v("John Bell Hood and the Battle of Nashville")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 12")]), _c('br'), _vm._v("The Army of Tennessee: Destroyed in Tennessee?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 13")]), _c('br'), _vm._v("Did John Bell Hood Accuse His Soldiers of Cowardice?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 14")]), _c('br'), _vm._v("A Callous Attitude: Did John Bell Hood “Bleed His Boys”?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 15")]), _c('br'), _vm._v("John Bell Hood and Frontal Assaults")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 16")]), _c('br'), _vm._v("Hood to His Men: “Boys, It is All My Fault”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 17")]), _c('br'), _vm._v("John Bell Hood and Words of Reproach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 18")]), _c('br'), _vm._v("Words of Praise for John Bell Hood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Chapter 19")]), _c('br'), _vm._v("John Bell Hood: Laudanum, Legends, and Lore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/afterword",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Afterword")]), _c('br'), _vm._v("by Eric Jacobson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Appendix 1")]), _c('br'), _vm._v("Excerpt from "), _c('i', [_vm._v("Advance and Retreat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Appendix 2")]), _c('br'), _vm._v("“An Eloquent Tribute to the Memory of the Late Gen. J. B. Hood”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Appendix 3")]), _c('br'), _vm._v("Jefferson Davis on Joe Johnston: Excerpt to the Confederate Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/biblio",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "P22_Dearest_Script"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Maps and photos have been placed throughout the book for the convenience of the reader.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0